import styled from 'styled-components/native';

export const ContentGuideDescritpion = styled.Text`
  font-family: ${({ theme }) => theme.fontFamily.core.w400};
  color: ${({ theme }) => theme.color.base.c8};
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 16px;
`;
